export default __webpack_public_path__ + "static/media/outro-copy-1.be0cba8a.png";